import React from 'react';
import { motion } from 'framer-motion';
import { QuickReply } from '../../types/chat';

interface QuickRepliesProps {
  replies: QuickReply[];
  onSelect: (reply: QuickReply) => void;
}

export function QuickReplies({ replies, onSelect }: QuickRepliesProps) {
  if (!replies?.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {replies.map((reply, index) => (
        <motion.button
          key={reply.id}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.1 }}
          onClick={() => onSelect(reply)}
          className="px-3 py-1.5 rounded-full bg-primary/10 hover:bg-primary/20 text-primary text-xs transition-colors"
        >
          {reply.text}
        </motion.button>
      ))}
    </div>
  );
}